import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    arrowButton: {
        width: 36,
        height: 36,
    },
});

export default styles;
